module.exports = __webpack_public_path__ + "static/img/center.f8b77b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gift/center.jpg
// module id = tmeX
// module chunks = 1